var exports = {
  "i": "xaee3c4fa--4aca96--wrapper",
  "R": "xaee3c4fa--4aca96--more-link",
};

module.exports = exports;
